import { observable, computed } from 'mobx';
import BaseStore from './BaseStore';

export default class StatusStore extends BaseStore {
    /**
     * 是否完成了初始化（获取了用户数据）
     */
    @observable initialized: boolean = false;

    /**
     * 当前请求数
     */
    @observable fetchCount: number = 0;

    /**
     * 是否显示头部组件
     */
    @observable public isShowHead: boolean = false;

    /**
     * 是否嵌入App
     */
    @observable public isApp: boolean = false;

    // 头部title
    @observable public appTitle: string;

    // 是否显示头部左侧返回按钮
    @observable public isShowLeftBackBtn: boolean = false;

    // 显示头部右侧按钮
    @observable public rightBtnType: string = 'backHall';

    // 是否触发头部分享按钮
    @observable public isGameAppdetail: boolean = false;


    // 是不是vip或者店主
    @observable public isVipOrShopkeeper: boolean;

    // 游戏id
    public gameId: string = '';

    // app端获取端openId，请求登陆端时候使用
    public openId: string;

    // 判断是否是游戏端
    public gameApp: boolean = false;

     // 判断是游戏端是否在记载
     @observable public isLoaded: boolean = false;

    // 游戏中头部默认的zIndex为39
    @observable public headZindex: number = 39;

    // 首页换肤
    @observable public homeSkin: any[] = [];

   

    /**
     * 当前是否有请求
     */
    @computed get isFetching(): boolean {
        return this.fetchCount > 0;
    }

    /**
     * 是否显示全局的加载组件
     */
    @computed get showSpin(): boolean {
        return this.isFetching || !this.initialized;
    }

    @computed get getHomeSkin(): any[] {
        return this.homeSkin.slice();
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/store/StatusStore.ts